import { render, staticRenderFns } from "./TreeValores.vue?vue&type=template&id=a9bfaa5c&"
import script from "./TreeValores.vue?vue&type=script&lang=js&"
export * from "./TreeValores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports